function state() {
  return {
    participantList: [],
    planList: [],
    organizationList: [],
    entityList: [],
    insurerList: [],
    policyList: [],
    benefitTypes: [],

    participant: {},
    plan: {},
    organization: {},
    entity: {},
    insurer: {},
    policy: {},

    bulkPolicyTemplate: "",
    log: [],
  };
}

export default state;
